import { render, staticRenderFns } from "./NominalRollForm.vue?vue&type=template&id=22fdea23&scoped=true"
import script from "./NominalRollForm.vue?vue&type=script&lang=js"
export * from "./NominalRollForm.vue?vue&type=script&lang=js"
import style0 from "./NominalRollForm.vue?vue&type=style&index=0&id=22fdea23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fdea23",
  null
  
)

export default component.exports